import { render, staticRenderFns } from "./backToTop.vue?vue&type=template&id=c52dbeee&scoped=true"
import script from "./backToTop.vue?vue&type=script&lang=js"
export * from "./backToTop.vue?vue&type=script&lang=js"
import style0 from "./backToTop.vue?vue&type=style&index=0&id=c52dbeee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c52dbeee",
  null
  
)

export default component.exports